(() => {
  function init(root) {
    if (root.dataset.accessoryReady) return;
    root.dataset.accessoryReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-accessory-variants]').textContent);
    const select = root.querySelector('[data-accessory-variant]');
    const form = root.querySelector('form');
    const add = root.querySelector('[data-accessory-add]');
    const showImage = id => {
      if (!id || !root.querySelector(`[data-accessory-media="${id}"]`)) return;
      root.querySelectorAll('[data-accessory-media]').forEach(el => { el.hidden = el.dataset.accessoryMedia !== String(id); });
      root.querySelectorAll('[data-accessory-thumbnail]').forEach(el => { el.setAttribute('aria-pressed', String(el.dataset.accessoryThumbnail === String(id))); });
    };
    const update = (changeUrl = true) => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      root.querySelector('[data-accessory-price]').textContent = variant.price;
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to cart' : variant.unavailableMarket ? 'Unavailable in this market' : 'Sold out';
      showImage(variant.mediaId);
      if (changeUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url); }
    };
    root.querySelectorAll('[data-accessory-thumbnail]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.accessoryThumbnail)));
    select.addEventListener('change', () => update());
    form.addEventListener('submit', event => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant?.available) { event.preventDefault(); root.querySelector('[data-accessory-status]').textContent = 'This option is unavailable. Please choose another option.'; }
    });
  }
  document.querySelectorAll('[data-accessory-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-accessory-product]').forEach(init));
})();
